import { singleOrGrouped } from '../types';
import { SinglePropertyBatchBaseAccordion } from './single';
import { GroupedPropertyBatchBaseAccordion } from './grouped';

export const PropertyBatchBaseAccordion = singleOrGrouped(
  SinglePropertyBatchBaseAccordion,
  GroupedPropertyBatchBaseAccordion
);
